<div [ngClass]="{'position-sticky': currency=='INR'}" class="tab-section">
  <mat-tab-group class="story-container" #tabs (selectedTabChange)="onTabChange($event)" [selectedIndex]="checkForUpdate()">
    <!-- Story Tab -->
    <mat-tab>
      <ng-template matTabLabel>
        <span>
          {{'Stories.storyText' | translatePipe | async}}
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-story-tab [storyDescription]="fundraiser?.story_description"></app-story-tab>
      </ng-template>
    </mat-tab>
    <!-- medical bill doc tab -->
    <mat-tab label="Documents" *ngIf="checkLength(fundraiser?.viewmedicalbill) && !params?.hide_el?.match('3')">
      <ng-template matTabLabel>
        <span>
          {{'Stories.documentText' | translatePipe | async}}
        </span> 
        <span class="tab-badge">
          {{ fundraiser?.viewmedicalbill.length }}
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-document [documents]="fundraiser?.viewmedicalbill" [sharedCounts]="sharedCounts"
                      [fundraiser]="fundraiser" [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicinfo" class="fr-document">
        </app-document>
      </ng-template> 
    </mat-tab>
    <!-- Updates tab -->
    <mat-tab label="Updates" *ngIf="updates && updates.total && hide_el" #updateTabRef>
      <ng-template matTabLabel>
        <span>{{'Stories.updatesText' | translatePipe | async}} </span>
        <span class="tab-badge">{{updates?.total}}</span>
      </ng-template>
      <!-- <ng-template matTabContent> -->
        <app-updates-tab [isDonated]="isDonated" [fundraiser]="fundraiser"
            [updates]="updates" [sharedCounts]="sharedCounts" [isFundraiserEnded]="isFundraiserEnded" [loadTab]="updateTabRef.isActive">
        </app-updates-tab>
      <!-- </ng-template> -->
    </mat-tab>

    <!-- contact tab -->
    <mat-tab label="Contact" *ngIf="fundraiser && !hide_el && !params?.hide_el?.match('2|3')" #contactTabRef>
      <ng-template matTabLabel>
        <span>Contact</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="mt-4"></div>
        <app-hospital-doctor-contact [fundraiser]="fundraiser"></app-hospital-doctor-contact>
      </ng-template>
    </mat-tab>

    <!-- comments tab -->
    <!-- <mat-tab label="Comments" *ngIf="comments && comments?.total && hide_el" #commentTabRef>
      <ng-template matTabLabel>
        <span>Comments </span>
        <span class="tab-badge">{{comments?.total}}</span>
      </ng-template>
      <ng-template matTabContent>
        <div inViewport (inViewportAction)="inViewPortListner($event, 'comments')" class="section-content">
          <app-module-loader [load]="inViewPort.comments && comments?.data?.length>0" moduleId="comment-card" selector="app-comment-card" [inputs]="{comments: comments, origin: 'stories', postCommentLabel: ('Stories.referAFriend.writeSomethingToCheer' | translatePipe | async)+fundraiser?.campaigner?.fname, campaignId: fundraiser?.id, customTag: fundraiser?.custom_tag}"></app-module-loader>
        </div>
      </ng-template>
    </mat-tab> -->
  </mat-tab-group>
</div>
<!-- Share buttons -->
<div *ngIf="variablesService.social && hide_el" #sharebtns class="share-buttonss">
  <app-fb-share *ngIf="setShare()" [count]="sharedCounts.fb" class="fbshare"
                [fundraiser]="fundraiser" [position]="11">
  </app-fb-share>
  <app-whatsapp-share class="whatsapp-share" [count]="sharedCounts" [basicInfo]="basicinfo"
                      [isFundraiserEnded]="isFundraiserEnded" [position]="isMobile ? 12 : 11">
  </app-whatsapp-share>
</div>
<!-- social share buttons -->
<div *ngIf="variablesService.social" style="display: none" #socailShare>
  <app-social-share [fundraiser]="fundraiser" [basicInfo]="basicinfo" [both]="true"
                    [isFundraiserEnded]="isFundraiserEnded" label="Share" [metaData]="variablesService?.metaDataOfPage">
  </app-social-share>
</div>
